(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('shopify-section-{{ section.id }}');
  if (!section) return;

  const tabButtons = Array.from(
    section.querySelectorAll('.layered-slideshow__tablist button[role="tab"]')
  );

  if (tabButtons.length < 2) return;

  let autoRotateInterval = null;

  function getActiveIndex() {
    return tabButtons.findIndex((button) => button.getAttribute('aria-selected') === 'true');
  }

  function goToNextSlide() {
    const activeIndex = getActiveIndex();
    const nextIndex = activeIndex === -1 ? 0 : (activeIndex + 1) % tabButtons.length;
    tabButtons[nextIndex].click();
  }

  function startAutoRotate() {
    if (autoRotateInterval) return;
    autoRotateInterval = setInterval(goToNextSlide, 4000);
  }

  function stopAutoRotate() {
    if (!autoRotateInterval) return;
    clearInterval(autoRotateInterval);
    autoRotateInterval = null;
  }

  startAutoRotate();

  section.addEventListener('mouseenter', stopAutoRotate);
  section.addEventListener('mouseleave', startAutoRotate);
  section.addEventListener('focusin', stopAutoRotate);
  section.addEventListener('focusout', startAutoRotate);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
